// extracted by mini-css-extract-plugin
export var lottie = "SearchRole-module--lottie--c284e";
export var our_vision_container = "SearchRole-module--our_vision_container--59bbf";
export var our_vision_lottie = "SearchRole-module--our_vision_lottie--e8e47";
export var our_vision_text = "SearchRole-module--our_vision_text--6b514";
export var search_role_container = "SearchRole-module--search_role_container--d2024";
export var search_vision_container = "SearchRole-module--search_vision_container--21bcd";